import React from 'react';

import { Box, Card, H1, Link, Separator, Text } from '@betterment/samba-react';

import { ContactDetails } from './ContactDetails';
import { PlanSupportAgentDetails } from './PlanSupportAgentDetails';
import { SectionTitle } from './SectionTitle';

import urlBuilder from '../../Shared/url-builder';

import type { SupportResources } from './types';

export const ContactUsCard: React.FC<{ support: SupportResources; isFourOhOneKOnly: boolean }> = ({
  support,
  isFourOhOneKOnly,
}) => (
  <Card css={{ p: 'space.300' }}>
    <Card.Header>
      <H1 variant="title200" css={{ mb: 'space.300' }}>
        Contact us
      </H1>
    </Card.Header>
    <Separator />
    <Card.Content>
      {!isFourOhOneKOnly && (
        <>
          <SectionTitle>Support for you</SectionTitle>
          <Box css={{ mb: 'space.200' }}>
            <Text as="p">
              <Link href={`mailto:${support.advisor.email}`}>{support.advisor.email}</Link>
            </Text>
            <Text as="p">{support.advisor.phone}</Text>
            <Text as="p" css={{ mb: 'space.0' }}>
              {support.advisor.weekdayHours}
            </Text>
            <Text as="p" variant="text50" color="text.weak" css={{ mt: 'space.100' }}>
              Use the{' '}
              <Link href={urlBuilder.getSecureSubmissionPortal()} target="_blank" rel="noopener noreferrer">
                secure submission portal
              </Link>{' '}
              to send files securely to the support team. Please make sure to email the team directly, as well, to
              provide context on your request. Never send sensitive documents in a regular email attachment.
            </Text>
          </Box>
          <Separator css={{ my: 'space.200' }} />
          <SectionTitle>Support for your clients</SectionTitle>
          <Box css={{ mb: 'space.200' }}>
            <ContactDetails contact={support.client} />
          </Box>
          <Separator css={{ my: 'space.200' }} />
        </>
      )}
      {support.fourOhOneKPlan && (
        <>
          <SectionTitle>Support for your 401(k) plans</SectionTitle>
          {support.fourOhOneKPlan.agent ? (
            <PlanSupportAgentDetails agent={support.fourOhOneKPlan.agent} />
          ) : (
            <Box>
              <ContactDetails contact={support.fourOhOneKPlan.contact} />
            </Box>
          )}
        </>
      )}
      {isFourOhOneKOnly && (
        <>
          <Separator css={{ my: 'space.200' }} />
          <SectionTitle>Support for your 401(k) plan participants</SectionTitle>
          <Box>
            <ContactDetails contact={support.client} />
          </Box>
        </>
      )}
    </Card.Content>
  </Card>
);
